import { useNavigate } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import { Panel, Button, ButtonToolbar, Loader, Placeholder } from 'rsuite';
import dayjs from 'dayjs';
import PlusRoundIcon from '@rsuite/icons/PlusRound';
import { useBroadcasts } from '../../../hooks';

const LocalizedFormat = require('dayjs/plugin/localizedFormat');
dayjs.extend(LocalizedFormat);

export default function BroadcastPage(props) {
	const { search } = props;
	const navigate = useNavigate();

	const {
		data,
		loading,
		totalRows,
		perPage,
		handlePageChange,
		handleSort,
		handlePerRowsChange
	} = useBroadcasts({ search });

	const columns = [
		{
			name: 'Broadcast Name',
			selector: (row) => row.name,
			sortable: true,
			grow: 2
		},
		{
			name: 'Hubspot List',
			selector: (row) => row.hubspotListName,
			sortable: true,
			grow: 2
		},
		{
			name: 'Send Time',
			selector: (row) => row.createdAt,
			sortable: true,
			sortField: 'sendAt',
			filterable: true,
			grow: 2,
			format: (row) => {
				return dayjs(row.sendAt).format('LLL');
			}
		},
		{
			name: 'Status',
			selector: (row) => row.status,
			sortable: true
		},
		{
			name: 'List Size',
			selector: (row) => row.job?.numAttempted || 0,
			right: true,
			sortable: true
		},
		{
			name: 'Delivered',
			selector: (row) => row.job?.numDelivered || 0,
			right: true,
			sortable: true
		},
		{
			name: 'Optouts',
			selector: (row) => row.job?.numRemoved || 0,
			right: true,
			sortable: true
		}
	];

	const handleRowClick = (row) => {
		navigate('/broadcasts/' + row._id);
	};

	const customStyles = {
		rows: {
			style: {
				cursor: 'pointer'
			}
		}
	};

	return (
		<main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
			<div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
				<h1 className="h2">Broadcasts</h1>
				<div className="btn-toolbar mb-2 mb-md-0">
					<ButtonToolbar>
						<Button
							key="btn_back"
							appearance="subtle"
							color="blue"
							onClick={() => {
								navigate('/broadcasts/new');
							}}
							startIcon={<PlusRoundIcon />}
						>
							New Broadcast
						</Button>
					</ButtonToolbar>
				</div>
			</div>
			<div className="container">
				<Panel bordered>
					<DataTable
						title=""
						columns={columns}
						data={data}
						customStyles={customStyles}
						progressPending={loading}
						progressComponent={
							<div>
								<Placeholder.Paragraph rows={8} />
								<Loader
									backdrop
									content="Hang on..."
									vertical
								/>
							</div>
						}
						pagination
						paginationServer
						paginationTotalRows={totalRows}
						defaultSortFieldId={3}
						defaultSortAsc={false}
						onChangeRowsPerPage={handlePerRowsChange}
						onChangePage={handlePageChange}
						onSort={handleSort}
						fixedHeader
						sortServer
						onRowClicked={handleRowClick}
						// expandableRows
						// expandableRowsComponent={ExpandedComponent}
						// conditionalRowStyles={conditionalRowStyles}
					/>
				</Panel>
			</div>
		</main>
	);
}
